import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Segment,
  Header,
  Grid,
  Image,
  Loader,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { fetchAPI } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';

import * as endpoints from '../../constants/apiEndpoints';

import Phone from '../../components/Phone';
import icPreferredGreen from '../../assets/icons/ic_preferred_green.svg';
import { TRANSLATION_FILES } from '../../constants/translation';

class LawyerDetails extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    basic: PropTypes.bool,
    cancelled: PropTypes.bool,
    lawyerID: PropTypes.string,
    verified: PropTypes.bool,
    canFetch: PropTypes.bool,
    onDone: PropTypes.func,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    t: PropTypes.func,
  }
  static defaultProps = {
    basic: false,
    cancelled: false,
    canFetch: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }
  componentDidMount() {
    // if (this.props.canFetch && this.props.lawyerID) {
    //   this.fetchLawyer();
    // }
  }
  componentWillReceiveProps(nextProps) {
    // const { canFetch, lawyerID, lawyer } = nextProps;
    // console.log('lawyer', lawyer);
    // if (
    //   (canFetch && canFetch !== this.props.canFetch) ||
    //   lawyerID !== this.props.lawyerID
    // ) {
    //   this.fetchLawyer(lawyerID);
    // }
  }
  // setLoading = (loading = false) => new Promise(res => this.setState({ loading }, () => res(loading)))
  // setLawyer = data => new Promise(res => this.setState({ data }, () => res(data)))
  // fetchLawyer = async (lawyerID = this.props.lawyerID) => {
  //   await this.setLoading(true);
  //   const { store } = this.context;
  //   let res;
  //   try {
  //     res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
  //       'X-Api-Token': process.env.LAWYER_API_TOKEN,
  //     }));
  //   } catch (e) {
  //     Bugsnag.notifyException(e);
  //     await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
  //     await this.setLoading(false);
  //     return;
  //   }

  //   if (res) {
  //     await this.setLawyer(res);
  //   }

  //   await this.setLoading(false);

  //   const { onDone } = this.props;
  //   if (onDone) {
  //     onDone(res);
  //   }
  // }
  render() {
    const { cancelled, verified, basic, data, t } = this.props;
    return (
      <Segment className="LawyerDetails" tertiary={cancelled} basic={basic}>
        <Grid verticalAlign="middle">
          <Grid.Column textAlign="left" width={16}>
            <Header color={cancelled ? 'red' : null}>{t(`${cancelled ? 'Cancelled' : 'Assigned'} Lawyer`)}</Header>
          </Grid.Column>
        </Grid>
        {
          data ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                {t('Name')}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                  {data.name}
                  {(verified || data.verified) ? <Image src={icPreferredGreen} height="15" style={{ marginLeft: '0.5em' }} /> : null}
                </div>
              </Grid.Column>
            </Grid>
          ) : (
            <Segment basic padded>
              <Loader active inline="centered" />
            </Segment>
          )
        }
        {
          data ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                {t('Law Firm')}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                {data.firm}
              </Grid.Column>
            </Grid>
          ) : null
        }
        {
          data ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                {t('Email')}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                {data.email}
              </Grid.Column>
            </Grid>
          ) : null
        }
        {
          data ? (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={6}>
                {t('Contact No')}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                <Phone
                  mobilePrefix={data.mobile_prefix}
                  mobile={data.mobile}
                />
              </Grid.Column>
            </Grid>
          ) : null
        }
      </Segment>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(LawyerDetails);



// WEBPACK FOOTER //
// ./src/containers/Lawyer/LawyerDetail.jsx